import { DcBaseComponent } from '@deleteagency/dc';
import { eventBus, events } from 'general/js/events';
import { EVENT_INPUT_UPDATED } from './events';

export default class SearchFiltersHorizontalComponent extends DcBaseComponent {
    static getNamespace() {
        return 'horizontal-filters';
    }

    onInit() {
        this._getState();

        const { resetButton } = this.refs;

        this.addListener( resetButton, 'click', (event)=>{
            const hiddenLocationInput = $('input[name="locationName"]');
            const hiddenCountyInput = $('input[name="countyName"]');
            const locationValue = hiddenLocationInput.val();
            const countyValue = hiddenCountyInput.val();

            this._checkState();
            
            hiddenLocationInput.val(locationValue);
            hiddenCountyInput.val(countyValue);            
        });        

        eventBus.addListener(events.EVENT_TAB_CHANGE, this._onTabChange);
        this._setFixedHeader();
        this._allFilters();
        this._inputClear();

        const searchInputWrapper = document.querySelector('.quick-search__input-wrapper');
        searchInputWrapper.addEventListener('change', (event) => {
            setTimeout(() => {
                const modalLocation = $('.search-results-all-filters-modal').find('.filter-quick-search__input-text'); 
                modalLocation.val(event.target.value);
            }, 500);
        });
        
    }

    _getState() {
        this.elements = [...this.element.elements];
        this.state = this.options.initialState;
    }

    _setState = () => {
        for (const el of this.elements) {
            if (typeof this.state[el.name] === 'undefined') continue;
            if (el.type === 'checkbox') {
                el.checked = this.state[el.name];                
            } else {
                el.value = this.state[el.name];
                if (el.type === 'hidden') {
                    eventBus.emit(EVENT_INPUT_UPDATED, el);
                }
            }
        }
    };


    _checkState = () => {
        this._setState();
        const selects = document.querySelectorAll('select');
        selects.forEach((select) => {            
            select.dispatchEvent(new Event('change'));
        });
    }

    _onTabChange = (id) => {
        const { viewTypeInput } = this.refs;
        viewTypeInput.value = id;
    };

    _setFixedHeader() {
        const fixedTarget = document.querySelector('.js-filters-horizontal');
        const filterContainer = fixedTarget.querySelector('.search-results-main-filters__inner');
        const observer = new IntersectionObserver((entries) => {
	        entries.forEach(entry => {
		    const target = entry.target
		    if (entry.isIntersecting) {
                fixedTarget.style.position = 'relative'
                if (window.location.hash.slice(1) === 'map') {
                    filterContainer.classList.remove('map_fixed');
                }
            } else {
                fixedTarget.style.position = 'fixed';
                if (window.location.hash.slice(1) === 'map') {
                    filterContainer.classList.add('map_fixed');
                }
            }
            })
        })
        observer.observe(document.querySelector('.js-filter-intersect'))
    }

    _inputClear () {
        const searchInput = $('.filter-quick-search__input-text');
        const hiddenLocationInput = $('input[name="locationName"]');
        const hiddenCountyInput = $('input[name="countyName"]')

        $(document).on('click', '.predictive__clear-btn', function() {
            hiddenLocationInput.each(function() {
                $(this).val('');
            });
            hiddenCountyInput.each(function() {
                $(this).val('');
            });
            searchInput.each(function() {
                $(this).val('');
            });
        });        
    }

    _allFilters() {
        const allFiltersTrigger = document.querySelector('.filter-quick-search__all-filters');
        const allFiltersModal = document.querySelector('.js-filters-vertical');
        const closeFilters = document.querySelector('.search-results-all-filters-modal__close');
        
        allFiltersTrigger.addEventListener('click', () => {
            if (allFiltersModal.classList.contains('active')) {
                allFiltersModal.classList.remove('active');
                return;
            }            
            
            allFiltersModal.classList.add('active');
            
            setTimeout(() => {
                const searchInput = $('.search-results-main-filters .filter-quick-search__input-text');
                if (searchInput.val() == '') {
                    const clearButton = document.querySelector('.search-results-all-filters-modal .predictive__clear-btn');
                    setTimeout(() => {
                        if (clearButton) {
                            $(clearButton).trigger('click');
                        } else {
                            console.error('Clear button not found.');
                        }
                    }, 10);
                }
            } , 100);
        });

        closeFilters.addEventListener('click', () => {
            allFiltersModal.classList.remove('active');
        });
    }

}
